import makeTable from "./makeTable";
import BASE_WIDTH_COLUMNS from "./constants/baseWidthColumns";

const { DATE } = BASE_WIDTH_COLUMNS;

export enum ColumnId {
	CREATED_AT = "createdAt",
	TYPE = "type",
	PROVIDER_NAME = "providerName",
	ALPHA_NAME = "alphaName",
	SIMPLE_STATUS = "simpleStatus",
	PHONE = "phone",
	TEXT = "text",
	SENDER = "sender",
	COMPANY = "company",
	TAXI_SERVICE = "taxiService",
}

export const translationTablePath =
	"pages.mainPage.pages.archives.tabs.messagesHistory.content.";

export const allColumns: ColumnId[] = Object.values(ColumnId);

const archivesMessagesHistory = makeTable({
	allIds: Object.values(ColumnId),
	i18tPath: (id) => `${translationTablePath}${id}`,
	defaultIds: allColumns,
	initialSortMethod: {
		column: ColumnId.CREATED_AT,
		type: "asc",
	},
	initialWidths: {
		[ColumnId.CREATED_AT]: DATE,
		[ColumnId.TYPE]: 150,
		[ColumnId.PROVIDER_NAME]: 200,
		[ColumnId.ALPHA_NAME]: 150,
		[ColumnId.SIMPLE_STATUS]: 150,
		[ColumnId.PHONE]: 150,
		[ColumnId.TEXT]: 300,
		[ColumnId.SENDER]: 150,
		[ColumnId.COMPANY]: 200,
		[ColumnId.TAXI_SERVICE]: 200,
	},
	initialResizable: Object.fromEntries(
		Object.values(ColumnId).map((id) => [id, true]),
	) as Record<ColumnId, boolean>,
	initialSortable: {
		[ColumnId.CREATED_AT]: true,
		[ColumnId.TYPE]: true,
		[ColumnId.PROVIDER_NAME]: true,
		[ColumnId.ALPHA_NAME]: true,
		[ColumnId.SIMPLE_STATUS]: true,
		[ColumnId.PHONE]: true,
		[ColumnId.TEXT]: true,
		[ColumnId.SENDER]: true,
		[ColumnId.COMPANY]: true,
		[ColumnId.TAXI_SERVICE]: true,
	},
});

export default archivesMessagesHistory;
